import { Box, Typography } from '@mui/material';
import { resolveMuiIconByName } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroCoverageCard = function IntroCoverageCard(props) {
  var item = props.item;
  var CoverageIcon = resolveMuiIconByName(item.iconName);
  /**
   * methods
   */

  var renderIcon = function renderIcon() {
    if (!CoverageIcon) return null;
    return /*#__PURE__*/_jsx(Box, {
      className: "flex h-12 w-12 items-center justify-center rounded-xl bg-[#EBF3F9] md:h-16 md:w-16",
      children: /*#__PURE__*/_jsx(CoverageIcon, {
        className: "h-6 w-6 fill-[#006DB0] md:h-8 md:w-8"
      })
    });
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex h-full flex-col space-y-4 rounded-2xl bg-white p-8 shadow-[0_16px_48px_-32px_rgba(0,109,176,0.25)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-32px_rgba(0,109,176,0.4)]",
    children: [renderIcon(), /*#__PURE__*/_jsx(Typography, {
      className: "text-xl font-black text-[#202020] md:text-2xl",
      children: item.title
    }), /*#__PURE__*/_jsx(Typography, {
      className: "text-sm font-medium text-[#202020] md:text-lg",
      children: item.desc
    })]
  });
};

export default IntroCoverageCard;